import React from "react";
import { withTranslation } from "react-i18next";

const PCAButton = (props) => {

  return (
    <div>
      <button style={{marginLeft: "1%"}} type="button" className="buttonContainer">
        <i className="fa-solid fa-diagram-project" id="icon"></i>
        <p id="text" style={{width: "75%"}}>{props.t("preprocessed.pca.button.title")}</p>
      </button>
    </div>
  );
};

export default withTranslation()(PCAButton);
